import { useCustomerData } from '@cinch-labs/customer-data-segment'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'

import styles from './deposit-contribution.module.css'

export function DepositContributionBanner() {
  const { trackEvent } = useCustomerData()
  const handleOnClick = () => {
    const data = {
      event: {
        name: 'click',
        category: 'link',
        action: 'navigate',
        label: 'selected electric cars',
      },
    }
    trackEvent({
      type: 'track',
      eventName: 'Promotion Clicked',
      data: {
        name: 'Deposit contribution promo banner',
        position: 'top banner',
      },
    })
    sendDigitalDataEvent(data)
  }
  return (
    <>
      <span className={styles.saveTag}>SAVE</span>
      <p className={styles.text}>
        Up to £2,000 towards your finance deposit on{' '}
        <a
          href="/find-vehicle?tags=deposit-contribution"
          onClick={handleOnClick}
        >
          selected electric cars
        </a>
        . Ends 4pm 24 Jan.{' '}
        <a href="/policies/deposit-contribution-electric-cars">T&Cs apply</a>.
        9.9% APR Representative.
      </p>
    </>
  )
}

export default DepositContributionBanner
